export class ChatbotFileDTO
{
    IdFile: string;
    FileName: string;
    ContentType: string;
    FileSize: number;
    FileExtension: string;
    BlobContainer: string;
    BlobFolder: string;
    BlobFileName: string;
    IsPublic: boolean;
    FileUri: string;
}

export class CreateUploadRequestDTO
{
    IdClient: string;
    IdProject: string;
    IdChat: string;
    FileName: string;        
}

export class CreateUploadResponseDTO
{        
    Url: string;
    Blobname: string;
}